import { Link } from "react-router-dom";
import { usePageTitle } from "../lib/pageTitle";
import "./NotFoundPage.scss";

export function NotFoundPage() {
  usePageTitle("Page not found");

  return (
    <div className="not-found page-enter container">
      <p className="not-found__code">404</p>
      <h1>Page not found</h1>
      <p className="not-found__lead">
        That URL doesn’t match anything on this site. It may have been moved or never existed.
      </p>
      <div className="not-found__actions">
        <Link to="/" className="btn btn--primary">
          Home
        </Link>
        <Link to="/portfolio" className="btn btn--ghost">
          Portfolio
        </Link>
        <Link to="/about" className="btn btn--ghost">
          About
        </Link>
      </div>
    </div>
  );
}
